import moment from "moment/moment";
import { useState, useEffect, useReducer } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../../utils/appUtils";
import TableDT from "../../../UI/TableDT";
import CardHeaderDashboardOnOff from "../../../utils/cardHeaderDashboardOnOff";
// import { reducerModalWindow } from "./ModalMfS";
import { reducerModalWindow, ModalMfS } from "./ModalMfS";
import { GetInfoMC, PostControlMC } from "../../../../api";
import { TabView, TabPanel } from 'primereact/tabview';
import { Modal } from 'react-bootstrap';

const ROUTE_URL = "/get_conn_mc";

function MfuncStations(props) {
    clearInterval(window.timer)
    const token = localStorage.getItem('token')
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(3);
    const [date, setDate] = useState();
    const [loadingStatus, setLoadingStatus] = useState(true)
    const [onoff, setOnoff] = useState(props.butchState);
    const [paramsModalWindow, dispatchModalWindow] = useReducer(reducerModalWindow, { show: false});
   const [currentPage, setCurrentPage] = useState(1);
    const [activeIndex, setActiveIndex] = useState(0)
    const [showParrot, setShowParrot] = useState(false)
    const [inputParrot, setInputParrot] = useState(0)
    const [arrTable, setArrTable] = useState([])


    let services = [
        { id: 1, name: "Доступность МС-ЛСН (комплект 1)", status: status, date: date },
        { id: 2, name: "Доступность МС-ЛСН (комплект 2)", status: status, date: date },
        { id: 3, name: "Доступность МС-ЛСН (комплект 3)", status: status, date: date },
        { id: 4, name: "Доступность МС-ЛСН (комплект 4)", status: status, date: date },
    ];

    const handleModal = (id) => {
        dispatchModalWindow({ type: 'def', id: id });
    };

    useEffect(() => {
        GetInfoMC(token, ROUTE_URL, activeIndex + 1, 0, 1).then((e) => {
            setArrTable(e.data.data)            
        })
        if (!date) {
            setDate(Date.now())
        }
    }, [activeIndex])

    const handleClick = (event) => {
        if (loading) return;
        event.preventDefault();
        event.target.blur();
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    }, []);

    const handleCloseModalWindow = (result) => {
        if (result.modalResult === 'mrOk') dtTable.Api.ajax.reload(null, false);
        dispatchModalWindow({ type: 'destroy' });
    };


    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }



    const handleCloseParrot = (event) => {
        setShowParrot(false);
        setInputParrot(0);
    }
    const handleBlur = () => {
        // При потере фокуса устанавливаем 0 если поле пустое
        if (inputParrot === '') {
            setInputParrot(0);
        }
    };

       const handleAcceptParrot = (id) => {
            setLoading(true);
            let forSend = { boost_signal: 1, signal_value: inputParrot }
            PostControlMC(token, id, forSend).then((e) => {
                setLoading(false);
                setShowParrot(false);
                setInputParrot(0);
            })
        }
    const clickReboot = (id) => {
            setLoading(true);
            let forSend = { reboot: 1 }
            PostControlMC(token, id, forSend).then((e) => {
                setLoading(false);
            })
        }
    
    
        const clickReset = (id) => {
            setLoading(true);
            let forSend = { reset: 1 }
            PostControlMC(token, id, forSend).then((e) => {
                setLoading(false);
            })
        }
    
        const clickDisableTransmitter = (id) => {
            setLoading(true);
            let forSend = { disable_transmitter: 1 }
            PostControlMC(token, id, forSend).then((e) => {
                setLoading(false);
            })
        }
        const handleChange = (e) => {
            const inputValue = e.target.value;
            
            // Разрешаем пустую строку для UX
            if (inputValue === '') {
                setInputParrot('');
              return;
            }
            
            const numValue = parseInt(inputValue, 10);
            
            // Проверяем диапазон
            if (!isNaN(numValue)) {
              if (numValue < 0) {
                setInputParrot(0);
              } else if (numValue > 4095) {
                setInputParrot(4095);
              } else {
                setInputParrot(numValue);
              }
            }
        };

    if (serverData === null)
        return <MainArea loading />;

    return (
        <>
            <MainArea>
                <div className={classCard} style={styleCard}>
                    <MainAreaHeader caption="Многофункциональные станции" />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index); setCurrentPage(1)}}> 
                            {services.map((e, i) => {
                                return (
                                    <TabPanel key={i} header={`Комплект ${i + 1}`}>
                                        <fieldset className="mfuncbutton-fieldset">
                                            {loading ? (<div className="spinner-border spinner-border-sm text-primary mfuncbutton-spinner"></div>) : <div className="cont-mfuncbuttons">
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReboot(i + 1) } >Перезапуск аппаратных средств</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReset(i + 1)} >Сброс параметров по умолчанию</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickDisableTransmitter(i + 1)} >Отключить радиоизлучение (установка мощности на 0)</button></div>
                                                }
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => setShowParrot(true)} >Установить мощность излучения</button></div>
                                                }
                                            </div>
                                            }
                                         </fieldset>
                                    <Modal show={showParrot} className={`modal-parrot`} onHide={handleCloseParrot}
                                        // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
                                        onExited={() => setShowParrot(false)} centered backdrop="static">
                                        <Modal.Header closeButton>
                                            <Modal.Title className="h6">Усилить радиосигнал</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="pb1-1">
                                    {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                            <fieldset className="mfuncbutton-fieldset">
                                                <input onBlur={handleBlur} min="0" max="4095" value={inputParrot} type="number" className='input-parrot' onChange={handleChange}></input>
                                            </fieldset>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                            <fieldset>
                                                <div className='cont-btn'>
                                                    <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseParrot}>Закрыть</button>
                                                    <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={() => handleAcceptParrot(i + 1)}>Применить</button>
                                                </div>
                                            </fieldset>
                                        </Modal.Footer>
                                    </Modal >
                             <div className="lower-line">
                                  <div className="text-cont">
                                    <div className="text text-tec">{`Текущее установленное значение мощности: ${arrTable[0]?.rf_power}`}</div>
                                  </div>
                                </div>
                                    </TabPanel>
                                )
                            })}
                        </TabView>
                </div>
                {/* </MainAreaBody> */}
            </MainArea >
            {/* {paramsModalWindow.show && <ModalMfS params={paramsModalWindow} handleClose={handleCloseModalWindow} />} */}
        </>
    );
}

let dtTable = {
    Api: null,
    getTableOptions: (crud) => {
        const dtOptions = {
            ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
            order: [[0, "asc"]],
            ajax: { type: "GET", url: ROUTE_URL },
            dom: getDataTableDom("lfip", 2, 1),
            columns: [
                // { orderable: false, searchable: false, data: null, className: "dt-center td-btn-action", render: DataTable.render.btnDelete(), },
                // { data: "timestamp", title: "Временная метка", render: DataTable.render.datetime(), },
                { data: "name", title: "Наименование", render: DataTable.render.text(), },
                { data: "type", title: "Тип", render: DataTable.render.text(), },
                { data: "description", title: "Описание", render: DataTable.render.text(), },
            ],
        };
        if ((crud & 1) === 0) {
            dtOptions.order = [[0, "asc"]];
            dtOptions.columns.splice(0, 1);
            dtOptions.dom = getDataTableDom("lfip", 1, 1);
        }

        console.log('dtOptions', dtOptions);


        return dtOptions;
    }
};

export default MfuncStations;
